<script setup>
  import { onUnmounted } from "vue";
  import { storeToRefs } from "pinia";
  import { useRouter } from "vue-router";

  import JobsTable from "@/components/Job/JobsTable.vue";
  import { IndexPageLayout, IndexPageFilters } from "@/components/App/IndexPage";
  import { FilterDropdown } from "@/components/episto-ui/filter-dropdown";
  import { useJobsStore } from "@stores/job/jobs";
  import { useJobsFilters } from "@/utils/composables/filters/useJobsFilters";

  const { jobSearchQuery } = storeToRefs(useJobsStore());
  const { initRefOnCreate, resetAllFilters } = useJobsStore();
  const router = useRouter();

  const { filterConfigs, activeFiltersCount, handleFilterChange, handleClear } = useJobsFilters();

  const create = () => {
    initRefOnCreate();
    router.push({ name: "JobForm" });
  };

  onUnmounted(() => resetAllFilters());
</script>

<template>
  <IndexPageLayout
    title="Jobs"
    action-label="New job"
    @action="create">
    <template #filters>
      <IndexPageFilters
        v-model:search-model-value="jobSearchQuery"
        search-placeholder="Search jobs">
        <template #filters>
          <FilterDropdown
            :filters="filterConfigs"
            :active-filters-count="activeFiltersCount"
            @toggle="handleFilterChange"
            @clear="handleClear" />
        </template>
      </IndexPageFilters>
    </template>

    <JobsTable />
  </IndexPageLayout>
</template>
